// Narrows the collection grid by keyword, client-side.
// Collections are rendered on a single page, so every product is in the DOM.
// Keyword and facet filters combine: facets re-render the grid server-side
// (facets.js replaces #ProductGridContainer), then the keyword is re-applied.
class FacetKeyword extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.debouncedApply = debounce(() => FacetKeyword.apply(), 150);

    this.input.addEventListener('input', (event) => {
      // Keep the input away from FacetFiltersForm, which re-renders on every form input
      event.stopPropagation();
      FacetKeyword.syncInputs(this.input);
      this.debouncedApply();
    });

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
    });

    FacetKeyword.observeGrid();
  }

  static get term() {
    const input = document.querySelector('facet-keyword input');
    return input ? input.value.trim() : '';
  }

  static syncInputs(source) {
    document.querySelectorAll('facet-keyword input').forEach((input) => {
      if (input !== source) input.value = source.value;
    });
  }

  static observeGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || FacetKeyword.observer) return;

    FacetKeyword.observer = new MutationObserver(() => FacetKeyword.apply());
    FacetKeyword.observer.observe(container, { childList: true });
  }

  static apply() {
    const term = FacetKeyword.term;
    const words = term.toLowerCase().split(/\s+/).filter(Boolean);
    const items = document.querySelectorAll('#product-grid > .grid__item');

    let visible = 0;
    items.forEach((item) => {
      const heading = item.querySelector('.card__heading');
      const title = heading ? heading.textContent.toLowerCase() : '';
      const match = words.every((word) => title.includes(word));
      item.hidden = !match;
      if (match) visible += 1;
    });

    FacetKeyword.renderCount(words.length ? visible : null, items.length);
    FacetKeyword.renderEmpty(term, words.length > 0 && items.length > 0 && visible === 0);
  }

  // Replaces the facet product count while a keyword is active, and restores it afterwards.
  static renderCount(visible, total) {
    const empty = document.getElementById('FacetKeywordEmpty');
    if (!empty) return;

    const counts = document.querySelectorAll('#ProductCount, [id="ProductCountDesktop"], .mobile-facets__count');
    counts.forEach((count) => {
      // facets.js rewrites the count after filtering, so treat unfamiliar content as the new original
      if (count.innerHTML !== count.dataset.keywordText) count.dataset.originalText = count.innerHTML;

      if (visible === null) {
        count.innerHTML = count.dataset.originalText;
      } else {
        count.textContent = empty.dataset.countTemplate.replace('[visible]', visible).replace('[total]', total);
      }
      count.dataset.keywordText = count.innerHTML;
    });
  }

  static renderEmpty(term, show) {
    const empty = document.getElementById('FacetKeywordEmpty');
    if (!empty) return;

    empty.hidden = !show;
    if (!show) return;

    const message = empty.querySelector('[data-template]');
    message.textContent = message.dataset.template.replace('[terms]', term);

    const link = empty.querySelector('[data-search-all]');
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('type', 'product');
    link.href = url.toString();
  }
}

if (!customElements.get('facet-keyword')) customElements.define('facet-keyword', FacetKeyword);
